import { render, staticRenderFns } from "./CompanyProfileAuxPage.vue?vue&type=template&id=f52c8806&scoped=true"
import script from "./CompanyProfileAuxPage.vue?vue&type=script&lang=js"
export * from "./CompanyProfileAuxPage.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfileAuxPage.vue?vue&type=style&index=0&id=f52c8806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52c8806",
  null
  
)

export default component.exports